import {tx, ptx, usePageText} from '../lib/page-text';
import { AnalyticsReport } from '../components/AnalyticsReport';
import { useT } from '../lib/i18n';
export function AnalyticsPage() {
  usePageText();
  const { t } = useT();
  return <div><h1 className="h1">{t('nav.analytics')}</h1><p className="subtitle">{tx("Broadcast activity, tracked viewers and audience engagement across your workspace.")}</p><AnalyticsReport /></div>;
}
